import { useEffect, useReducer } from 'react'
import { CancelToken } from '@/utils/fetch'

const initialState = {
  data: [],
  loading: true,
  error: null
}

function reducer (state, action) {
  switch (action.type) {
    case 'starting':
      return { ...state, loading: true, error: null }
    case 'done':
      return { ...state, loading: false, data: action.data }
    case 'error':
      return { ...state, loading: false, error: action.error }
  }
  return state
}

export function useDataLoader (dataSource, filter, filterData, transform) {
  const [state, dispatch] = useReducer(reducer, initialState)
  useEffect(() => {
    if (!dataSource) return
    let disposed = false
    const cancellation = CancelToken.source()
    dispatch({ type: 'starting' })
    let options = { cancelToken: cancellation.token }
    if (typeof filterData === 'undefined' || filterData === null) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      filterData = options
      options = undefined
    }
    dataSource(filterData, options).then(result => {
      if (disposed) return
      if (result && result.success === false) {
        throw result
      } else {
        if (filter) {
          result = result ? filter(result, filterData) : []
        }
        if (transform) {
          result = transform(result)
        }
        dispatch({ type: 'done', data: result })
      }
    }).catch(error => {
      if (disposed) return
      dispatch({ type: 'error', error })
    })

    return function cleanup () {
      disposed = true
      cancellation.cancel('unmount useDataLoader hook')
    }
  }, [dataSource, filter, filterData, transform])

  return state
}



// WEBPACK FOOTER //
// ./src/hooks/useDataLoader.js